import React from 'react'
import styles from './ModalHeader.module.scss'
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg'

const ModalHeader = ({ headerClassName, closeModal, children, hasCloseButton, themeMode }) => {
  return (
    <div className={[styles.modalHeader, styles[themeMode], headerClassName].join(' ')}>
      {children && (
        <span className={styles.modalTitle} id='modalTitle'>
          {children}
        </span>
      )}
      {hasCloseButton && (
        <button
          type='button'
          aria-label='Close Modal'
          aria-labelledby='close-modal'
          className={styles.modalClose}
          onClick={closeModal}
          id='closeModalId'
        >
          <div className={styles.iconContainer}>
            <CloseIcon />
          </div>

        </button>
      )}
    </div>
  )
}

export default ModalHeader
